// Topnavigation.js
import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useUser } from "../../context/UserContext";

export default function Topnavigation({
  toggleSidebar,
  isSidebarCollapsed,
  selectedAgent,
  setSelectedAgent,  
}) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const location = useLocation();
  const { user } = useUser();
  const dropdownRef = useRef(null);
  const profileRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setIsProfileOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  //
  const displayName =
    user?.userName ||
    (user?.firstName ? `${user.firstName} ${user.lastName || ""}`.trim() : "");

  const displayEmail = user?.email || "";
  const displayNumber = user?.mobile || "";

  return (
    <div className="top-navigation-header">
      <div className="sidebar-toggle" onClick={toggleSidebar}>
        <i className={`burgericon fa-solid ${isSidebarCollapsed ? "fa-angle-right" : "fa-bars"}`}></i>
      </div>      

      <div className="profile-section" ref={profileRef}>
        <div
          className="profile-button"
          onClick={() => setIsProfileOpen(!isProfileOpen)}
        >
          <span>
            <i className="fa-regular fa-user profileicon"></i>
          </span>
        </div>

        {isProfileOpen && (
          <div className="profile-dropdown">
            <div className="profile-content">
              <ul>
                <li>
                  <strong>Username:</strong> {displayName}
                </li>
                <li>
                  <strong>Email:</strong> {displayEmail}
                </li>
                <li>
                  <strong>Number:</strong> {displayNumber}
                </li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
